/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Human review
 */
class HumanReview {
  state: string;
  state_message: string = "";

  constructor(state: string, state_message: string = "") {
    this.state = state;
    this.state_message = state_message;
  }
}

/**
 * Revision
 */
export class Revision {
  /**
   * Revision id
   */
  id: string = "0";

  /**
   * Revision parent
   */
  parent?: string[];

  /**
   * Revision parent ids
   */
  parent_ids: string[] = [];

  /**
   * Create time
   */
  create_time: string = new Date().toISOString();

  /**
   * Agent
   */
  agent: string;

  /**
   * Processor
   */
  processor?: string;

  /**
   * Human review
   */
  human_review?: HumanReview;

  /**
   * Last revision id
   */
  lastRevisionId?: string;

  constructor(
    reviewedDocumentJson: any,
    humanRevisionState: string,
    humanRevisionStateMessage: string,
    userId: string
  ) {
    this.parent_ids = [];
    this.lastRevisionId = "0";
    reviewedDocumentJson.revisions = reviewedDocumentJson.revisions || [];
    const lastRevision = reviewedDocumentJson.revisions
      .slice()
      .sort((a: Revision, b: Revision) => {
        return (a < b);
      })
      .pop();
    this.lastRevisionId = lastRevision?.id || this.lastRevisionId;
    lastRevision?.parent_ids?.push(this.lastRevisionId);
    this.parent_ids = lastRevision?.parent_ids || [this.lastRevisionId];
    this.id = String((parseInt(this.lastRevisionId || "") || 0) + 1);
    if (humanRevisionState !== "rejected") {
      humanRevisionState = "succeeded";
    };
    this.create_time = new Date().toISOString();
    this.human_review = new HumanReview(humanRevisionState,humanRevisionStateMessage);
    this.agent = userId;
  }
}
